
export { CONFIG } from "./main5.js"